module.exports = __webpack_public_path__ + "static/img/3c.e960934.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3c.jpg
// module id = q6Rr
// module chunks = 0